<template>
  <div class="sfnedit f-column mh-0">
    <RangeBuilderV2
      ref="rangeBuilder"
      class="flex-1"
      :namespace="namespace"
      :builderMode="'mode_nodelock'"
      :toolTabs="['tools', 'bulk_tools', 'frequency']"
      :onStart="false"
      :hspotsHidden="true"
      :canInitialize="true"
      :defaultToCheckFold="false"
      :hasLayoutSwitch="false"
      :hasRangePopup="false"
      :useHex="useHex"
      :grouping="grouping"
      :showBetsIn="showBetsIn"
      :showEvIn="showEvIn"
      :mobile="mobile"
      :solElite="solElite"
      :hasPremiumGameformat="hasPremiumGameformat"
      :street="hSpot_street"
      :hotkeysPressed="hotkeysPressed"
      :solDynamic="l_sol_dynamic"
      :solStatic="l_sol_static"
      :filterCombos="filterCombos"
      :swLayoutStudy="'swv_layout_horizontal'"
      :swSpacingStudy="'swv_layout_spacing_medium'"
      :heroGroup="heroDetail.group"
      :heroGroupId="heroDetail.group_id"
      :heroGroupsIds="heroDetail.groups_ids"
      :tableMouseover="tableMouseover"
      :solution_picked="l_sol_static.solution_picked"
      :filterCategories="filterCategories"
      :applyFilterActionName="null"
      :viewProps="$store.getters.sol_view_viewProps"
      :hSpot="$store.getters.sol_data_hSpot"
      :solStreet="$store.getters.sol_data_street"
      :loadingConfirm="loadingNewSol"
      :loadingStrategy="loadingFreqSol"
      @update:tablegroups="handleUpdateTableGroups"
      @update:actionssliders="handleActionSlidersUpdate"
      @click:confirm="apply"
    >
      <template #after>
        <StudyMessageOverlay
          v-if="sol_messages"
          style="z-index: 5"
          :showLoadingTips="false"
          :messages="sol_messages"
          :street="hSpot_street"
          :solElite="solElite"
          :pageKey="'solutions'"
          :canAISolve="false"
        />
      </template>
    </RangeBuilderV2>
  </div>
</template>

<script>
import { nextTick } from 'vue'

import { SNK } from '@/helpers/helpers'
import { getSolProps, toggleSolProps, getCombosSolution } from '@/helpers/solution'
import { getHistoryUrlParams } from '@/store/gamestate/gamestate'

import RangeBuilderV2 from '@/components/Practice/RangeBuilder/RangeBuilderV2'
import StudyMessageOverlay from '@/components/Poker/Overlays/StudyMessageOverlay'

import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'
import fetch_mix from '@/mixins/fetch_mix'
import { all_streets } from '@/helpers/constants'

export default {
  name: 'SolfigrNodeLock',
  components: {
    RangeBuilderV2,
    StudyMessageOverlay,
  },
  mixins: [format_mix, float_mix, fetch_mix],
  props: {
    primaryNamespace: { required: true, type: String },
    namespace: { required: true, type: String },
    hotkeysPressed: Array,
  },
  data() {
    this.lockedTableGroups = []
    this.apiSolData = null
    return {
      sol_call: {
        conf: {},
        loading: false,
        loaded: false,
        status: 0,
      },
      isoBuckets_call: {
        conf: {},
        loading: false,
        loaded: false,
        status: 0,
      },

      solDataUpdated: 0,
      loadingNewSol: false,
      loadingFreqSol: false,
    }
  },
  created() {
    this.solution_picked = []
    this.tableGroups = this.$store.getters.ske_tableGroups()
    this.combos = this.$store.getters.ske_combos()
    this.solution = []
    this.solData = []
    this.hero = {}
    this.opponent = {}
    this.catDraws = []
    this.catHands = []
    this.catEqBuckets = []
    this.catEqBucketsAdvanced = []
    this.getData()

    this.$store.dispatch(SNK('sol_filters_reset', this.namespace))
  },
  methods: {
    getData() {
      const params = this.$store.getters[SNK('solparams_strategy', this.primaryNamespace)]
      const callId = `poker/solution/${new URLSearchParams(params)}`
      this.sol_call.conf = {
        endpoint: 'poker/solution/',
        hasCancel: true,
        waitForCache: true,
        callId,
        params,
        gwCacheId: callId,
        gwCacheAdd: true,
      }
      const isoCallId = `poker/buckets_${params.board}`
      this.isoBuckets_call.conf = {
        endpoint: 'poker/buckets/',
        callId: isoCallId,
        gwCacheId: isoCallId,
        waitForCache: true,
        hasCancel: true,
        params: { board: params.board },
      }

      const solCall = this.fch_getData(this.sol_call)
      const bucketsCall = this.fch_getData(this.isoBuckets_call)
      Promise.all([solCall, bucketsCall]).then(values => {
        if (values[0].error || values[1].error) return
        const { data: solData } = values[0]
        const { data: isoBucketsData } = values[1]
        this.setSolProps({ solData, isoBucketsData })
        this.startTour()
      })
    },
    startTour() {
      setTimeout(() => {
        this.$store.dispatch('globals_action', 'component_triggered_tour_NodelockDialog')
      }, 120)
    },
    setSolProps({ solData, isoBucketsData }) {
      if (!this.$refs.rangeBuilder) return // closed before data loaded

      const res = getSolProps({
        apiData: solData,
        handsIsometric: isoBucketsData.hands_to_buckets,
        combos: this.combos,
        tableGroups: this.tableGroups,
      })
      this.solData = res.solData
      this.solution_picked = res.solution_picked
      this.tableGroups = res.tableGroups
      this.combos = res.combos
      this.solution = res.solution
      this.hero = res.hero
      this.opponent = res.opponent
      this.catDraws = res.catDraws
      this.catHands = res.catHands
      this.catEqBuckets = res.catEqBuckets
      this.catEqBucketsAdvanced = res.catEqBucketsAdvanced

      this.solDataUpdated = Date.now()

      // dont know why but without nextTick it does not work well
      nextTick(() => {
        this.$refs.rangeBuilder.initialize()
      })
    },
    toggleSolProps() {
      const res = toggleSolProps({
        filter: this.filterCombos,
        solution: this.solution,
        combos: this.combos,
        tableGroups: this.lockedTableGroups,
      })

      if (!this.$refs.rangeBuilder) return
      this.$refs.rangeBuilder.nodelock_slidersRepaint({
        tableGroups: res.tableGroups,
        lockValue: undefined,
        keepLocks: true,
      })
    },
    // ---
    handleUpdateTableGroups(tableGroups) {
      this.lockedTableGroups = tableGroups
    },
    async handleActionSlidersUpdate({ actions, keepLocks }) {
      const heroIndex = 0
      // console.log(actions)
      const actions_locked = actions.map(a => (a.is_locked ? a.code : null)).filter(i => i)
      const desired_frequencies = actions
        .filter(i => i.active && !i.is_locked)
        .map(i => ({
          action: i.code,
          frequency: i.strategy,
        }))
      if (!desired_frequencies.length) return

      const {
        last_node_lock, //
        hands_selected,
        parent_solution_id,
        historyParams,
      } = this.getApiParams()
      const hands_locked = keepLocks ? last_node_lock.hands_locked : []
      const { action_history } = last_node_lock
      const { strategy } = last_node_lock

      const dataParams = {
        preflop_actions: historyParams.preflop_actions,
        flop_actions: historyParams.flop_actions,
        turn_actions: historyParams.turn_actions,
        river_actions: historyParams.river_actions,
        custom_solution_id: parent_solution_id,
        desired_frequencies,
        hands_selected: this.filterCombos.status !== 'inactive' ? hands_selected : [],
        manual_lock: {
          action_history,
          strategy,
          hands_locked,
        },
        actions_locked,
      }

      this.loadingFreqSol = true
      const result = await this.$store.dispatch('api_call', {
        method: 'post',
        data: dataParams,
        endpoint: 'poker/custom-solutions/node-lock-frequencies/',
        hasCancel: true,
        message: {
          type: 'error',
        },
      })
      this.loadingFreqSol = false

      if (result.error?.canceled) return
      if (!this.$refs.rangeBuilder) return

      const apiStrategy = result.response?.data?.strategy
      if (!apiStrategy) return

      const combos = this.combos.map(cc => {
        if (!cc.players[heroIndex].range) return cc
        return {
          ...cc,
          solution: cc.solution.map(ss => ({
            ...ss,
            strategy: apiStrategy[ss.order].strategy[cc.api_index],
          })),
        }
      })
      const tableGroups = this.tableGroups.map(gg => {
        const l_combos = gg.combos.map(cc => combos[cc.api_index])
        const combosInRange = l_combos.filter(cc => cc.players[heroIndex].range)
        return {
          ...gg,
          combos: l_combos,
          solution: getCombosSolution({ combos: combosInRange, solution: this.solution_picked }),
        }
      })

      if (!this.$refs.rangeBuilder) return
      this.$refs.rangeBuilder.nodelock_slidersRepaint({
        tableGroups,
        lockValue: !keepLocks ? false : undefined,
        keepLocks,
      })
    },
    getApiParams() {
      const heroIndex = 0
      const hSpot = this.$store.getters[SNK('history_spot', this.primaryNamespace)]

      let hSpots = this.$store.getters[SNK('history_spots', this.primaryNamespace)]
      hSpots = hSpots.filter(i => i.id < hSpot.id)

      const historyParams = getHistoryUrlParams({
        history_spots: hSpots,
        includeShowdown: false,
      })

      const lastStreetIdx = all_streets.findIndex(i => i === hSpot.street)
      const startedStreets = all_streets.filter((i, idx) => idx <= lastStreetIdx)

      const parent_solution_id = hSpot.custom_solution_id || ''

      const allCombos = this.lockedTableGroups.reduce((acc, i) => [...acc, ...i.combos], [])

      const hands_locked = []
      const hands_selected = []
      allCombos.forEach(cc => {
        hands_locked[cc.api_index] = cc.is_locked
        hands_selected[cc.api_index] = !!cc.players[heroIndex].range
      })

      const strategy = this.solution_picked.map((aa, aaIdx) => {
        const l_strategy = []
        allCombos.forEach(cc => {
          l_strategy[cc.api_index] = cc.solution[aaIdx].strategy
        })
        return {
          action: aa.code,
          strategy: l_strategy,
        }
      })

      const { solElite } = this
      const last_node_lock = {
        strategy,
        hands_locked,
        action_history: [
          solElite.is_preflop ? historyParams.preflop_actions : '',
          ...(startedStreets.includes('flop') ? [historyParams.flop_actions] : []),
          ...(startedStreets.includes('turn') ? [historyParams.turn_actions] : []),
          ...(startedStreets.includes('river') ? [historyParams.river_actions] : []),
        ],
      }
      const res = {
        last_node_lock,
        parent_solution_id,
        historyParams,
        hands_selected,
      }
      return res
    },
    async apply() {
      if (this.loadingNewSol) return

      this.loadingNewSol = true
      const { last_node_lock, parent_solution_id } = this.getApiParams()
      const dataParams = {
        last_node_lock,
        parent_solution_id,
      }
      // !!!!
      // /solutions data on previous nodes (current-street-only) can be changed by nodeedit on current node
      // so clear all cached solution data - ideally just this street
      // docs
      // https://cotton-shadow-79c.notion.site/NodeLocks-ea181b38d52d4596841b3b81eb8dc803
      this.$store.dispatch('api_cache_clear', null, { root: true })
      await this.$store.dispatch('api_call', {
        method: 'post',
        data: dataParams,
        endpoint: 'poker/custom-solutions/',
        action: SNK('slfrm_handleNodeUpdate', this.primaryNamespace),
        hasCancel: false,
        // Err message is on store handler
      })
      this.loadingNewSol = false
    },
  },
  computed: {
    heroDetail() {
      return this.$store.getters.sol_detail_players[0]
    },
    tableMouseover() {
      return this.$store.getters[SNK('sol_detail_tableMouseover', this.namespace)]
    },
    filterCombos() {
      return this.$store.getters[SNK('sol_filter_combos', this.namespace)]
    },
    // filterActive() {
    // return this.$store.getters[SNK('sol_filter_active', this.namespace)]
    // },
    filterCategories() {
      return this.$store.getters[SNK('sol_filter_categories', this.namespace)]
    },

    l_sol_dynamic() {
      const res = {
        tableGroups: this.tableGroups,
        combos: this.combos,
        solution: this.solution,
      }
      // console.log('l_sol_dynamic', res)
      return this.solDataUpdated ? res : res
    },
    l_sol_static() {
      const res = {
        solution_picked: this.solution_picked,
        solData: this.solData,
        hero: this.hero,
        opponent: this.opponent,
        catDraws: this.catDraws,
        catHands: this.catHands,
        catEqBuckets: this.catEqBuckets,
        catEqBucketsAdvanced: this.catEqBucketsAdvanced,
      }
      return this.solDataUpdated ? res : res
    },

    isPreflop() {
      return this.$store.getters.sol_data_street === 'preflop'
    },
    useHex() {
      return this.$store.getters.sw_actions_grouping === 'swv_grouping_none'
    },

    hSpot() {
      return this.$store.getters[SNK('history_spot', this.primaryNamespace)]
    },
    hSpot_street() {
      return this.hSpot?.street
    },
    sol_hsBoard() {
      return this.$store.getters[SNK('history_spot_board', this.primaryNamespace)]
    },

    gameformat() {
      return this.$store.getters.gameformat
    },
    solElite() {
      return this.$store.getters[SNK('sol_elite', this.primaryNamespace)]
    },
    hasPremiumGameformat() {
      const { subs } = this.$store.getters.user_info
      const anyPremiumPurchased = subs.some(i => i.plan.tier === 'PREMIUM')
      const anyElitePurchased = subs.some(i => i.plan.tier === 'ELITE')
      return !!(anyPremiumPurchased || anyElitePurchased)
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    showEvIn() {
      return this.$store.getters.show_ev_in
    },

    // --- messages
    hasEliteSingleFlopOnly() {
      const flopBoard = this.$store.getters[SNK('street_board', this.primaryNamespace)]('flop')
        .filter(i => i !== 'Ee')
        .join('')

      return (
        this.solElite.is_using && this.solElite.must_upgrade && flopBoard && flopBoard !== 'QsTs7h'
      )
    },

    hasElitePreflopOnly() {
      return (
        this.$store.getters.sol_data_street === 'preflop' &&
        this.solElite.is_using &&
        this.solElite.must_upgrade
      )
    },
    preflopOnlyGametype() {
      return this.$store.getters.preflopOnlyGametype
    },
    sol_noBoardCards() {
      return this.hSpot_street !== 'preflop' && this.sol_hsBoard.some(i => i.includes('E'))
    },
    sol_loading() {
      return this.sol_call.loading
    },
    sol_loaded() {
      return this.sol_call.loaded
    },
    sol_status() {
      return this.sol_call.status
    },
    sol_error() {
      return this.sol_call.error
    },
    historyCall() {
      return this.$store.getters.api_get(SNK('api_poker_history', this.primaryNamespace))
    },
    nextActionsCall() {
      return this.$store.getters.api_get(SNK('api_poker_next_actions', this.primaryNamespace))
    },
    historyLoading() {
      return this.nextActionsCall?.loading || this.historyCall?.loading
    },
    historyError() {
      return this.nextActionsCall?.error || this.historyCall?.error
    },
    sol_messages() {
      // TODO unify solMessages with builder and popups
      // return [
      // 'loading',
      // 'error_loading_solution',
      // 'error_400_TREE_IS_TOO_BIG',
      // 'custom_sols_flop_elite_only',
      // '204',
      // '204_elite',
      // '403',
      // '429',
      // 'preflopOnlyGametype',
      // 'select_board_strategy',
      // ]
      // console.log(this.historyError)
      const solutionTooBig =
        this.historyError?.status === 400 && this.historyError?.data?.code === 'TREE_IS_TOO_BIG'

      const opts = [
        {
          key: 'loading',
          val: this.isoBuckets_call.loading || this.sol_call.loading,
        },

        { key: 'loading', val: this.solElite.loading_what === 'custom_solution' },
        { key: 'custom_sols_flop_elite_only', val: this.hasEliteSingleFlopOnly },
        { key: 'custom_sols_preflop_elite_only', val: this.hasElitePreflopOnly },
        { key: 'error_400_TREE_IS_TOO_BIG', val: solutionTooBig },
        { key: '204_elite', val: this.solElite.is_using && this.sol_status === 204 },

        { key: 'preflopOnlyGametype', val: !this.solElite.want_use && this.preflopOnlyGametype },
        { key: 'select_board_strategy', val: this.sol_noBoardCards },

        { key: '204', val: this.sol_status === 204 },
        { key: '403', val: this.sol_status === 403 },
        { key: '429', val: this.sol_status === 429 },

        { key: 'error_loading_solution', val: this.isoBuckets_call.error || this.sol_call.error },
      ]
      let res = null
      opts.forEach(i => {
        if (!res && i.val) {
          res = [i.key]
        }
      })

      return res
    },
  },
  watch: {
    filterCombos() {
      if (!this.sol_call.loaded) return
      this.toggleSolProps()
    },
  },
}
</script>

<style lang="scss" scoped>
.sfnedit {
}
</style>
